import { render, staticRenderFns } from "./AdEdit.vue?vue&type=template&id=ec1df950&scoped=true"
import script from "./AdEdit.vue?vue&type=script&lang=js"
export * from "./AdEdit.vue?vue&type=script&lang=js"
import style0 from "./AdEdit.vue?vue&type=style&index=0&id=ec1df950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1df950",
  null
  
)

export default component.exports